import {Component, OnInit} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgFor, NgClass, NgIf } from '@angular/common';
import { JSONEditor } from 'vanilla-jsoneditor';
import { HttpClient } from '@angular/common/http';
import { ProcessService } from 'src/app/services/user-services/process.service';

@Component({
    selector: 'app-configurationI18n',
    templateUrl: './configurationI18n.component.html',
    styleUrls: ['./configurationI18n.component.scss'],
    standalone: true,
    imports: [NgFor, RouterLink, NgClass, NgIf]
})
export class ConfigurationI18nComponent implements OnInit {
  currentJson;
  content;
  currentLanguage = 'fr';
  url = 'https://livinfrance-bk.s3.eu-west-3.amazonaws.com/assets/i18n/fr.json';

  constructor(
    private http: HttpClient,
    private processService: ProcessService
    ) { }

  ngOnInit(): void {
    this.configEditor(this.currentLanguage);
  }

  changeLanguage(lang){
    this.currentLanguage = lang;
    this.url = 'https://livinfrance-bk.s3.eu-west-3.amazonaws.com/assets/i18n/' + lang +'.json';
    const k = document.getElementById('jsoneditor');
    k.remove();
    const ed =  document.createElement("div");
    ed.setAttribute("id", "jsoneditor");
    const element = document.getElementById("containerEditor");
    element.appendChild(ed);
    this.configEditor(lang);
  }

  configEditor(lang){

    fetch(this.url).then(res => res.json())
    .then(json => {
      this.currentJson = json;
      const content =  {
        text: undefined,
        json: json
      }
      const editor = new JSONEditor({
        target: document.getElementById('jsoneditor'),
        props: {
          content : content,
          onChange: (updatedContent, previousContent, { contentErrors, patchResult }) => {
           this.processService.updateTranslations(lang,updatedContent).subscribe(d => console.log(d));
          }
        }
      })
  
    });
  }


}
